module.exports = __webpack_public_path__ + "assets/webgl/Frame_Ornament_base.1001.jpg.dxt.5e768ebe.ktx";